import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import { useGlobalState } from "../Context/GlobalStateContext";
import { SortTheList, getAccessSettings } from "../Shared/Utility";
import Confirmation from "../App/Confirmation";
import * as XLSX from "xlsx";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
function COPAInvoicesData() {
  const globalState = useGlobalState();

  const [COPAInvoicesGridData, setCOPAInvoicesGridData] = useState<any>([]);
  const [COPAInvoicesTotalData, setCOPAInvoicesTotalData] = useState<any>([]);

  const [showAnimation, setShowAnimation] = useState(false);
  const [IsImporterLoggedIn, setIsImporterLoggedIn] = useState(false);

  const [invoicesFilter, setInvoicesFilter] = useState({
    YearID: 2023,
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    IBBScorecardID: 0,
    PFIDealerID: 0,
    PFIBrandID: 3,
    CurrencyID: 0,
  });

  const [importerList, setImporterList] = useState<any>([]);

  const [programList, setProgramList] = useState<any>([]);

  const [quarterList, setQuarterList] = useState<any>([]);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = invoicesFilter.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = invoicesFilter.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = invoicesFilter.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = invoicesFilter.ProgramID;

    setInvoicesFilter((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
    }));

    IBBProgramGetProgramListForScorecard(
      IBBProgramID,
      QuarterID,
      IBBScorecardID,
      PFIDealerID
    );
  }, []);

  useEffect(() => {
    if (invoicesFilter.ProgramID > 0) {
      IBBProgramGetScorecardListForScorecard();
    }
  }, [invoicesFilter.ProgramID, invoicesFilter.QuarterID]);

  useEffect(() => {
    if (invoicesFilter.IBBScorecardID > 0 || IsImporterLoggedIn) {
      IBBCOPAUploadDataGetDataForCOPAInvoices();
    }
  }, [invoicesFilter.IBBScorecardID, invoicesFilter.PFIBrandID]);

  useEffect(() => {
    if (invoicesFilter.IBBScorecardID > 0 || IsImporterLoggedIn) {
      getCurrencyIDByIBBScorecardID();
    }
  }, [invoicesFilter.IBBScorecardID]);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number,
    IBBScorecardID: number,
    PFIDealerID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = invoicesFilter.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = QuarterID;
    //object.pfidealerid = PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setInvoicesFilter((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            setImporterList(result[1]);
            if (result[1].length > 0) {
              let IBBScorecardID = result[1][0].PID;
              let PFIDealerID = result[1][0].PFIDealerID;
              setInvoicesFilter((prevState: any) => ({
                ...prevState,
                IBBScorecardID: IBBScorecardID,
                PFIDealerID: PFIDealerID,
              }));
            }

            setQuarterList(result[2]);
            if (QuarterID == 0) {
              let QuarterID = result[2][0].PID;
              setInvoicesFilter((prevState: any) => ({
                ...prevState,
                QuarterID: QuarterID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetScorecardListForScorecard() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = invoicesFilter.ProgramID;
    object.numericquarter = invoicesFilter.QuarterID;
    //object.pfidealerid = invoicesFilter.PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetScorecardListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            setImporterList(result[0]);

            if (result[0].length > 0) {
              let IBBScorecardID = result[0][0].PID;
              let PFIDealerID = result[0][0].PFIDealerID;
              setInvoicesFilter((prevState: any) => ({
                ...prevState,
                IBBScorecardID: IBBScorecardID,
                PFIDealerID: PFIDealerID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBCOPAUploadDataPFIDealerGetImporterList() {
    let object = {} as any;
    object.appid = AppContext.App;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBCOPAUploadData/IBBCOPAUploadDataPFIDealerGetImporterList",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            let PFIDealerID = result[0][0].PFIDealerID;
            setInvoicesFilter((prevState: any) => ({
              ...prevState,
              PFIDealerID: PFIDealerID,
            }));

            setImporterList(result[0]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBCOPAUploadDataGetDataForCOPAInvoices() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.programid = invoicesFilter.ProgramID;
    object.numericyear = invoicesFilter.YearID;
    object.numericquarter = invoicesFilter.QuarterID;
    object.pfibrandid = invoicesFilter.PFIBrandID;
    object.ibbscorecardid = invoicesFilter.IBBScorecardID;
    object.pfidealerid = invoicesFilter.PFIDealerID;
    setCOPAInvoicesGridData([]);
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBCOPAUploadData/IBBCOPAUploadDataGetDataForCOPAInvoices",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = [];
          result = response.data.Data;
          setCOPAInvoicesTotalData(result[0]);
          //setCOPAInvoicesGridData(result[1]);
          const deepCopy1 = JSON.parse(JSON.stringify(result[1]));
          const deepCopy2 = JSON.parse(JSON.stringify(result[1]));
          setThisGridListDataWithoutFilters(deepCopy1);
          setCOPAInvoicesGridData(deepCopy2);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBCOPAUploadDataDeleteRecordCustom(IBBCOPAUploadDataID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbcopauploaddataid = IBBCOPAUploadDataID;

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBCOPAUploadData/IBBCOPAUploadDataDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          IBBCOPAUploadDataGetDataForCOPAInvoices();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getCurrencyIDByIBBScorecardID() {
    var filtered = importerList.filter(
      (item: any) => item.PFIDealerID == invoicesFilter.PFIDealerID
    );
    if (filtered.length > 0) {
      setInvoicesFilter((prevState: any) => ({
        ...prevState,
        CurrencyID: filtered[0].CurrencyID,
      }));
    }
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBCOPAUploadDataDeleteRecordCustom(obj.SelectedID);
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = []; //[...COPAInvoicesGridData] as any;
    l_data = [...FilterData];
    //setCOPAInvoicesGridData([...l_data]);

    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setCOPAInvoicesGridData(deepCopy);
    setThisGridListData(deepCopy[0]);
    thisGridListDataRef.current = deepCopy[0];
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  ////  Sorting Starts    /////

  const [filters, setFilters] = useState(["", "D"]);

  useEffect(() => {
    SetSortingImage();
  }, [COPAInvoicesGridData]);

  function SetSortingImage() {
    if (COPAInvoicesGridData && COPAInvoicesGridData.length > 0 && document.getElementById("imgSortPeriodYear")) {
      (
        document.getElementById("imgSortPeriodYear") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

      (
        document.getElementById("imgSortMarketName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

      (
        document.getElementById("imgSortModelName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

      (document.getElementById("imgSortVIN") as HTMLInputElement).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

      (
        document.getElementById("imgSortInvoiceDocNo") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

      (document.getElementById("imgSortRev_LC") as HTMLInputElement).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (
        document.getElementById("imgSortRev_USD") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (
        document.getElementById("imgSortSalesQuantity") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (document.getElementById("imgSortVDM_LC") as HTMLInputElement).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (
        document.getElementById("imgSortVDM_USD") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (document.getElementById("imgSortVDM") as HTMLInputElement).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    }
    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="13px" height="15px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="13px" height="15px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  // Download in Excel function
  function DownloadClientsDataInExcel(id: any, name: any) {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      document.getElementById(id)
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, name);

    XLSX.writeFile(wb, name + ".xlsx");
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />

      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Quarterly Invoiced Vehicles</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div style={{ width: "33.33%" }}>
              <select
                className="select-md"
                value={invoicesFilter.ProgramID}
                onChange={(e) => {
                  setInvoicesFilter((prevState: any) => ({
                    ...prevState,
                    ProgramID: Number(e.target.value),
                    QuarterID: 0,
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  IBBProgramGetProgramListForScorecard(
                    Number(e.target.value),
                    0,
                    0,
                    0
                  );
                }}
              >
                {programList &&
                  programList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"program" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>

              <select
                style={{ marginLeft: 5 }}
                className="select-md"
                value={invoicesFilter.QuarterID}
                onChange={(e) => {
                  setInvoicesFilter((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }));
                }}
              >
                {quarterList &&
                  quarterList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"quarter" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>

              {/* <select
                className="select-md"
                value={invoicesFilter.YearID}
                onChange={(e) =>
                  setInvoicesFilter((prevState: any) => ({
                    ...prevState,
                    YearID: Number(e.target.value),
                  }))
                }
              >
                {AppContext.YearList &&
                  AppContext.YearList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"year" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>
              <select
                style={{ marginLeft: 5 }}
                className="select-md"
                value={invoicesFilter.QuarterID}
                onChange={(e) =>
                  setInvoicesFilter((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }))
                }
              >
                {AppContext.QuarterList &&
                  AppContext.QuarterList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"quarter" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select> */}

              <select
                style={{ marginLeft: 5 }}
                className="select-md"
                value={invoicesFilter.PFIBrandID}
                onChange={(e) =>
                  setInvoicesFilter((prevState: any) => ({
                    ...prevState,
                    PFIBrandID: Number(e.target.value),
                  }))
                }
              >
                {AppContext.BrandList &&
                  AppContext.BrandList.map((Item: any, index: any) => (
                    <>
                      {index > 0 && (
                        <option value={Item.PID} key={"brand" + Item.PID}>
                          {Item.Name}
                        </option>
                      )}
                    </>
                  ))}
              </select>
            </div>
            {globalState.AppAccessLevelData.DID == 0 && (
              <div>
                <select
                  className="select-lg"
                  value={invoicesFilter.IBBScorecardID}
                  onChange={(e) => {
                    var filtered = importerList.filter(
                      (item: any) => item.PID == Number(e.target.value)
                    );
                    let PFIDealerID = 0;
                    if (filtered.length > 0)
                      PFIDealerID = filtered[0].PFIDealerID;
                    setInvoicesFilter((prevState: any) => ({
                      ...prevState,
                      IBBScorecardID: Number(e.target.value),
                      PFIDealerID: PFIDealerID,
                    }));
                  }}
                >
                  {importerList &&
                    importerList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"importer" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>
            )}
            <span style={{ width: "33.33%" }}></span>

            <a
              className="btn-primary"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel(
                  "tblQuarterlyInvoicedVehicles",
                  "QuarterlyInvoicedVehicles"
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
          <div className="section-table remove-scroll">
            {COPAInvoicesGridData && COPAInvoicesGridData.length > 0 && (
              <ColumnFilterCheckboxList
                DataType={1}
                RefreshFilters={refreshFilters}
                ClearFilters={clearFilters}
                GridData={COPAInvoicesGridData}
                ColumnName={selectedColumnName}
                ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
                GetFilteredLists={getFilteredLists}
                ReturnAllFilterdLists={{}}
                ClickPosition={clickPosition}
                Orientation={"Center"}
                ColumnOrientation={[
                  { Name: "PeriodYear", Orientation: "Right" },
                ]}
              />
            )}

            <table
              className="part-head trend-table fixed-table copa-in-d-table"
              id="tblQuarterlyInvoicedVehicles"
            >
              <thead>
                {COPAInvoicesTotalData.length > 0 && (
                  <tr className="JLRTotal">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th className="text-right">
                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                        invoicesFilter.CurrencyID
                      )}
                      {COPAInvoicesTotalData[0].Rev_LC?.toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }
                      )}
                    </th>
                    <th className="text-right">
                      $
                      {COPAInvoicesTotalData[0].Rev_USD?.toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }
                      )}
                    </th>
                    <th className="text-right">
                      {COPAInvoicesTotalData[0].SalesQuantity?.toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }
                      )}
                    </th>
                    <th className="text-right">
                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                        invoicesFilter.CurrencyID
                      )}
                      {COPAInvoicesTotalData[0].VDM_LC?.toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }
                      )}
                    </th>
                    <th className="text-right">
                      $
                      {COPAInvoicesTotalData[0].VDM_USD?.toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }
                      )}
                    </th>
                    <th></th>
                    <th className="col-del"></th>
                  </tr>
                )}
                <tr>
                  <th>
                    <span
                      className="c-pointer"
                      onClick={(e) => ShowColumnFilterList(e, "PeriodYear")}
                      data-function="ShowColumnFilterList"
                    >
                      Month
                    </span>

                    <a
                      onClick={() => LoadWithSelectedSort("PeriodYear")}
                      title="Sort By Month"
                    >
                      <span id="imgSortPeriodYear"></span>
                    </a>
                  </th>
                  <th>
                    <span
                      className="c-pointer"
                      onClick={(e) => ShowColumnFilterList(e, "MarketName")}
                      data-function="ShowColumnFilterList"
                    >
                      Market
                    </span>

                    <a
                      onClick={() => LoadWithSelectedSort("MarketName")}
                      title="Sort By Market"
                    >
                      <span id="imgSortMarketName"></span>
                    </a>
                  </th>
                  <th>
                    <span
                      className="c-pointer"
                      onClick={(e) => ShowColumnFilterList(e, "ModelName")}
                      data-function="ShowColumnFilterList"
                    >
                      Model
                    </span>

                    <a
                      onClick={() => LoadWithSelectedSort("ModelName")}
                      title="Sort By Model"
                    >
                      <span id="imgSortModelName"></span>
                    </a>
                  </th>
                  <th>
                    <span
                      className="c-pointer"
                      onClick={(e) => ShowColumnFilterList(e, "VIN")}
                      data-function="ShowColumnFilterList"
                    >
                      VIN
                    </span>

                    <a
                      onClick={() => LoadWithSelectedSort("VIN")}
                      title="Sort By VIN"
                    >
                      <span id="imgSortVIN"></span>
                    </a>
                  </th>
                  <th>
                    <span className="c-pointer">INV_NO</span>

                    <a
                      onClick={() => LoadWithSelectedSort("InvoiceDocNo")}
                      title="Sort By INV_NO"
                    >
                      <span id="imgSortInvoiceDocNo"></span>
                    </a>
                  </th>
                  <th>
                    <span className="c-pointer">Rev - LC</span>

                    <a
                      onClick={() => LoadWithSelectedSort("Rev_LC")}
                      title="Sort By Rev - LC"
                    >
                      <span id="imgSortRev_LC"></span>
                    </a>
                  </th>
                  <th>
                    <span className="c-pointer">Rev - $</span>

                    <a
                      onClick={() => LoadWithSelectedSort("Rev_USD")}
                      title="Sort By Rev - $"
                    >
                      <span id="imgSortRev_USD"></span>
                    </a>
                  </th>
                  <th>
                    <span className="c-pointer">Volume</span>

                    <a
                      onClick={() => LoadWithSelectedSort("SalesQuantity")}
                      title="Sort By Volume"
                    >
                      <span id="imgSortSalesQuantity"></span>
                    </a>
                  </th>
                  <th>
                    <span className="c-pointer">VRM - LC</span>

                    <a
                      onClick={() => LoadWithSelectedSort("VDM_LC")}
                      title="Sort By VRM - LC"
                    >
                      <span id="imgSortVDM_LC"></span>
                    </a>
                  </th>
                  <th>
                    <span className="c-pointer">VRM - $</span>

                    <a
                      onClick={() => LoadWithSelectedSort("VDM_USD")}
                      title="Sort By VRM - $"
                    >
                      <span id="imgSortVDM_USD"></span>
                    </a>
                  </th>
                  <th>
                    <span className="c-pointer">VRM</span>

                    <a
                      onClick={() => LoadWithSelectedSort("VDM")}
                      title="Sort By VRM"
                    >
                      <span id="imgSortVDM"></span>
                    </a>
                  </th>
                  <th className="col-del"></th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={"program" + index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td className="text-right">{item.PeriodYear}</td>
                          <td>{item.MarketName}</td>
                          <td>{item.ModelName}</td>
                          <td>{item.VIN}</td>
                          <td className="text-right">{item.InvoiceDocNo}</td>
                          <td className="text-right">
                            {AppContext.GetCurrencyIconBasedOnCurrencyID(
                              invoicesFilter.CurrencyID
                            )}
                            {item.Rev_LC?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            })}
                          </td>
                          <td className="text-right">
                            $
                            {item.Rev_USD?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            })}
                          </td>
                          <td className="text-right">{item.SalesQuantity}</td>
                          <td className="text-right">
                            {AppContext.GetCurrencyIconBasedOnCurrencyID(
                              invoicesFilter.CurrencyID
                            )}
                            {item.VDM_LC?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            })}
                          </td>
                          <td className="text-right">
                            $
                            {item.VDM_USD?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            })}
                          </td>
                          <td className="text-right">
                            {item.VDM?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                            %
                          </td>

                          <td className="col-del">
                            {globalState.AppAccessLevelData.DID == 0 &&
                              getAccessSettings(2, 10) > 1 && (
                                <>
                                  <a
                                    className="btn-primary btn-grid"
                                    onClick={() => {
                                      globalState.setConfirmationObject({
                                        ShowPopup: true,
                                        Heading: "Confirmation ",
                                        Message:
                                          "Are you sure you want to delete this record?",
                                        ID: 1,
                                        SelectedID: item.IBBCOPAUploadDataID,
                                      });
                                    }}
                                    title="Delete"
                                  >
                                    <img
                                      src="images/delete.svg"
                                      width={15}
                                      height={15}
                                    />
                                  </a>
                                </>
                              )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default COPAInvoicesData;
